import { render, staticRenderFns } from "./SafetyVestInfo.vue?vue&type=template&id=8221e684"
import script from "./SafetyVestInfo.vue?vue&type=script&lang=js"
export * from "./SafetyVestInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports